
<template>
  <v-card v-role="roles">
    <v-progress-linear style="margin : 0 auto ; height:10px" indeterminate v-if="isLoading"></v-progress-linear>

    <v-card-title>
            Lista dos Estudantes na turma {{ this.$store.state.objturma.pkTurma }}

            <v-chip v-if="true" class="ma-2" close color="pink" label outlined>
              {{ (!this.$store.state.fromMinhaTurmas) ? this.$store.state.objturma.turmadescricao :
                this.$store.state.objturma.descricao }}
            </v-chip>
            <v-spacer></v-spacer>
           
            <v-row>
              <v-col md="6">
                 <span>Selecionado : <strong style="font-size:22px;">{{ $store.state.novadescricaoSelecionado }}</strong></span>
              </v-col>
              <v-col md="5">
                <v-combobox
                  v-model="filtroTurmaSelected"
                  label="Opções de Filtro"
                  :items="filtros"
                  item-text="descricao"
                  @change="filtrarEstudantePorEstado()"
                >

            </v-combobox>
              </v-col>
            </v-row>
            <v-row style="position:fixed;background-color:yellow;" v-if="progresso">
              <v-col>
                <v-progress-circular :size="50" color="green" indeterminate></v-progress-circular>
                <span style="font-size:15px;">{{ tipoDocumento }} abrirá em uma nova janela...Por favor aguarde</span>
              </v-col>

            </v-row>
            <v-spacer></v-spacer>
            <img @click="dialogExcel()" style="margin-left:30px; cursor: pointer;" width="30px" src="../../assets/download.png">
            <img @click="carregarEstudantesTurmaPDF()" style="margin-left:30px; cursor: pointer;" width="30px" src="../../assets/pdf_exibir.png">
       
    </v-card-title>
    <div v-if="$store.state.hasMessage" :class="$store.state.classMessage">
      {{ $store.state.textMessage }}
    </div>
    <v-data-table :headers="headers" :items="listaAlunosFiltered" :items-per-page="50" class="elevation-1">
      <template v-slot:item.photo="{ item }">
         <img  class="photomouse" :src="getPhoto(item)" alt="avatar" width="30px;" />
      </template>

      <template v-slot:item.nome="{ item }">
        <v-tooltip v-if="item.estado_estudante === '0'" top>
          <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs"  v-on="on" ><s style="color:red">{{item.nome}}</s></span>
          </template>
          <span>Este aluno foi eliminado da turma.</span>
        </v-tooltip>

        <span v-if="item.estado_estudante === '1'">{{item.nome}}</span>

         <v-tooltip top v-if="item.estado_estudante === '2'">
          <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs"  v-on="on" ><s style="color: #a39127">{{item.nome}}</s></span>
          </template>
         <span>Este aluno teve a sua matrícula trancada.</span>
        </v-tooltip>
      </template>

       <template v-slot:item.sexo="{ item }">
        <span >{{(item.sexo === 'F')?'Femenino':'Masculino'}}</span>
       </template>

      <template v-slot:item.action="{ item }">
        <v-menu bottom origin="center center" transition="scale-transition">
          <template v-slot:activator="{ on }">
            <v-btn fab dark color="teal" style="color:white" v-on="on">
              <v-icon>menu</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item :disabled="item.estado_estudante !== '1'" v-if="(isIlha || isNascer) && isintegrado" @click="carregarcartaoestudante(item)"> <v-icon  class="mr-2" style="color:#808080">print</v-icon> <span> - Cartão de Estudante</span></v-list-item>
            <v-list-item :disabled="item.estado_estudante !== '1'" v-if="$store.state.objturma.idAno_Academico === 4 && item.resultado === 'Transita'" @click="certificadoPago(item)"><v-icon>print</v-icon> -Certificado</v-list-item>
            <v-list-item :disabled="item.estado_estudante !== '1'" @click="declaracao_semNotas(item)"><v-icon>print</v-icon> <span> - Declaração sem notas</span></v-list-item>
            <v-list-item :disabled="item.estado_estudante !== '1'" @click="declaracao_comNotas(item)"><v-icon>print</v-icon> <span> - Declaração com notas</span></v-list-item>
            <v-list-item :disabled="item.estado_estudante !== '1'" v-if="isESCA" @click="declaracao_aproveitamento(item)"><v-icon>print</v-icon> <span> - Declaração de Aproveitamento</span></v-list-item>
            <v-list-item :disabled="item.estado_estudante !== '1'" v-if="(isIlha)" @click="oficioVagas(item)"> <v-icon  class="mr-2" style="color:#808080">print</v-icon> <span> - Ofício de confirmação de vaga</span></v-list-item>
            <v-list-item :disabled="item.estado_estudante !== '1'" @click="editItem(item)"> <v-icon>insert_drive_file</v-icon> <span> -Boletim</span></v-list-item>
            <v-list-item :disabled="item.estado_estudante !== '1'" v-if="$store.state.objturma.idAno_Academico === 4" @click="carregarHistoricoAcademico(item)"> <v-icon>insert_drive_file</v-icon> <span> -Histórico de Notas</span></v-list-item>
            <v-list-item :disabled="item.estado_estudante !== '1'" @click="showEliminar(item)"  v-if="role === 'ROLE_ADM'"> <v-icon color="red">delete</v-icon> <span style="color:red;">-Eliminar</span></v-list-item>
            <v-list-item :disabled="item.estado_estudante !== '1'"  @click="showAddDisciplina(item)" v-if="role === 'ROLE_ADM'"> <v-icon>add</v-icon> <span> -Add
                disciplina Pauta</span></v-list-item>
          </v-list>
        </v-menu>

        <!--<v-img  style="color:green" src="../assets/boletim.jpg" width="80px"  class="mr-2" @click="editItem(item)"></v-img>-->
      </template>
    </v-data-table>

    <!-- =============== Dialgo add Pauta ================================================ -->

    <template>
      <v-row justify="center">
        <v-dialog v-model="dialogoPauta" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="text-h5">Adicionar disciplina na Pauta</span><br>
            </v-card-title>
            <div v-if="$store.state.hasMessage" :class="$store.state.classMessage">
              {{ $store.state.textMessage }}
            </div>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field label="Estudante" required v-model="editedItemPauta.nome"
                      :disabled="true"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field label="Turma" v-model="editedItemPauta.turma" :disabled="true"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field label="Classe" required v-model="editedItemPauta.classe"
                      :disabled="true"></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field label="Anolectivo" v-model="editedItemPauta.anoLectivo" required
                      :disabled="true"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="8">
                    <v-combobox :items="disciplinas_" item-text="disciplina" v-model="editedItemPauta.disciplina"
                      label="Selecione a disciplina" return-object required></v-combobox>
                  </v-col>

                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click="dialogoPauta = false">
                Fechar
              </v-btn>
              <v-btn color="green darken-1" text @click="AdicionarDisciplinaPauta()">
                Salvar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <!-- ==================== FIM DIALOGO ================================================ -->

    <!-- ============================================================================ -->
    <v-row justify="center">
      <v-dialog v-model="dialog_delete" persistent max-width="490">
        <v-card>
          <v-card-title class="headline">Eliminar estudante</v-card-title>
          <v-card-text>Tem a certeza que pretente continuar com esta operação ? </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="dialog_delete = false">Cancelar</v-btn>
            <v-btn color="green darken-1" text @click="Delete()">Continuar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!--=================================================================================-->

    <!--======================================EXPORTAR PARA O EXECEL==============================================-->
    <template>
      <div class="text-center">
        <v-dialog v-model="dialog" width="500">
          <v-card>
            <v-card-title class="headline grey lighten-2" primary-title>
              Exportar para Excel - Deseja Continuar
            </v-card-title>

            <v-card-text>
              Clique para Continuar
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn style="background-color:red;color:white" @click="dialog = false">Cancelar</v-btn>
              <export-excel :data="listEstudantfromPauta" :fields="campos">
                <v-btn @click="dialog = false">Continuar</v-btn>
              </export-excel>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>

        <!-- ************************************************************************* -->

                              <v-dialog
                    v-model="dialogOpcoes"
                    persistent
                    max-width="490"
               >

                    <v-card>
                      <v-overlay :value="overlay_card">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
                    <v-card-title class="text-h5">
                         Opções de Impressão
                    </v-card-title>
                    <v-card-text>
                         <label>Selecione a opção de impressão</label>
                         <v-row>
                            <v-col cols="12" sm="12">
                               <v-combobox
                                  v-model="opcaoImpressao"
                                  :items="[{id:1,descricao:'Apenas os Aprovados'},{id:2,descricao:'Apenas os Reprovados'},{id:3,descricao:'Todos'},]"
                                  label="Selecione"
                                  item-text="descricao"
                                  item-value="id"
                                  return-object
                               >
                               </v-combobox>
                            </v-col>
                            <v-col cols="12" sm="12">
                            <v-select
                              v-model="modelo"
                              item-value="id"
                              item-text="descricao"
                              :items="modelosImpressao"
                              label="Modelo de Impressão"
                              return-object
                            ></v-select>
                        </v-col>
                         </v-row>
                    </v-card-text>
                    <v-card-actions>
                         <v-spacer></v-spacer>
                         <v-btn
                         color="red darken-1"
                         text
                         @click="dialogOpcoes = false"
                         >
                         Cancelar
                         </v-btn>
                         <v-btn
                         color="green darken-1"
                         text
                         @click="callGerarLista()"
                         >
                         Imprimir
                         </v-btn>
                    </v-card-actions>
                    </v-card>
               </v-dialog>

          <!-- ***************************************************************************** -->
    <!--==========================================================================================-->
    <!--==========================================================================================-->
    <listaestudante v-if="$store.state.showDialogGuia.listaestudante" />
    <guiatransferencia v-if="$store.state.showDialogGuia.guia" />
    <fichadadosbiograficoacademico v-if="$store.state.showDialogGuia.ficha" />
    <historicoacademico v-if="$store.state.showDialogGuia.historico" />
    <cartaoescolar v-if="$store.state.showDialogGuia.cartao" />
    <declaracaonotas v-if="$store.state.showDialogGuia.declaracao_nota" />
    <declaracao v-if="$store.state.showDialogGuia.declaracao" />
    <cartarecomendacao v-if="$store.state.showDialogGuia.carta" />
    <declaracaoaproveitamento v-if="$store.state.showDialogGuia.declaracao_aproveitamento" />
    <oficioconfirmacaovaga @fecharComponente="fecharTelaComponente" v-if="menucomponente===1" />
  </v-card>
</template>

<script>
import axios from '../../plugins/axios'
import photostudent from '../../utilitarios/photo.services'
import oficioconfirmacaovaga from '../tec-ped/componentes/oficiovaga.vue'
import Swal from 'sweetalert2'

const ls = require('local-storage')
export default {
  components: {
    listaestudante: () => import('../tec-ped/componentes/listaestudante.vue'),
    declaracao: () => import('../tec-ped/componentes/declaracao.vue'),
    oficioconfirmacaovaga,
    guiatransferencia: () => import('../tec-ped/componentes/guiatransferencia.vue'),
    fichadadosbiograficoacademico: () => import('../tec-ped/componentes/fichadadosbiografico.vue'),
    historicoacademico: () => import('../tec-ped/componentes/historicoacademico.vue'),
    cartaoescolar: () => import('../tec-ped/componentes/cartao.vue'),
    declaracaonotas: () => import('../tec-ped/componentes/declaracao_nota.vue'),
    cartarecomendacao: () => import('../tec-ped/componentes/carta.vue'),
    declaracaoaproveitamento: () => import('../tec-ped/componentes/declaracao_aproveitamento.vue')
  },
  data: () => ({
    modelosImpressao: [{ id: 1, descricao: 'IMS' }, { id: 2, descricao: 'Local' }],
    modelo: { id: 1, descricao: 'IMS' },
    menucomponente: 0,
    insignia: ls.get('insignia'),
    logotipo: ls.get('logotipo'),
    rascunhoimge: ls.get('urlReport') + 'readfile/rascunho-1.png',
    isnotas: false,
    dialogOpcoes: false,
    opcaoImpressao: null,
    listaAlunosFiltered: [],
    data: null,
    filtroTurmaSelected: null,
    roles: 'func',
    overlay_card: false,
    formatter: 0,
    html: ``,
    tipoDocumento: 'O certificado',
    on: false,
    json_meta: [
      [
        {
          'key': 'charset',
          'value': 'utf-8'
        }
      ]
    ],

    campos: {
      'Nome Completo': 'nome',
      'Número de Matricula': 'idMAtricula',
      'Resultado': 'resultado'
    },
    headers: [
      {
        text: 'Foto',
        align: 'start',
        sortable: false,
        value: 'photo'
      },
      { text: 'Nome', value: 'nome' },
      { text: 'Matricula', value: 'idMAtricula' },
      { text: 'Sexo', value: 'sexo' },
      { text: 'Resultado', value: 'resultado' },
      { text: 'Registrado por', value: 'autor' },
      { text: 'Registrado em', value: 'data_registro' },
      { text: 'Operações permitidas', value: 'action', sortable: false }
    ],
    text: '',
    backTo: null,
    editedpk: false,
    progresso: false,
    progresso_2: false,
    dialog_delete: false,
    disciplinas_: [],
    classe: '',
    dialog: false,
    dialogoDisabilita: false,
    dialogo: false,
    idanoacademico: 0,
    filtros:[{id:1,descricao:'Todos'},{id:2,descricao:'Estudantes activos'},{id:3,descricao:'Estudantes eliminados'},{id:4,descricao:'Matrículas trancadas'}],
    turmasFiltered: [],
    offset: true,
    btn_description: '',
    turma_selecionada: '',
    publicar_status: false,
    isLoading: true,
    idturma: 0,
    dialogo_turma: false,
    closeOnClick: true,
    dialogoPauta: false,
    listaPautasBloquadas: [],
    classe_selecionada: '',
    btn_activacao: false,
    listaDeClassesPorLancarNotas: [],
    listEstudantfromPauta: [],
    editedIndex: -1,
    editedItem: {
      ResidenteEm: 0,
      anoLectivo: '',
      auto_data: '',
      autor: null,
      bi: '',
      certificado: null,
      data_: '',
      data_2: '',
      dataemissaobi: '',
      datanascimento: '',
      descricao: '',
      descricao_certificado: '',
      email: '',
      emitirCertificado: null,
      emitirCertificadoAutor: null,
      emitirCertificadoData: null,
      emitirCertificadoValidacaoStep: null,
      fkPessoa: 0,
      fkTurma: 0,
      flag_dados_preparados: null,
      flag_transferencia: 0,
      foto: null,
      idAnoLectivo: null,
      idAno_Academico: 0,
      idCurso: 0,
      idInscricao_na_turma: '',
      idMAtricula: '',
      idMatricula: '',
      idMunicipio: 0,
      idPEssoa: '',
      idPerfil: 0,
      idTurma: '',
      idano_academico: '',
      idinstituicao: 0,
      instituicao: 0,
      instituicaodescricao: '',
      morada: '',
      nome: '',
      nomedamae: '',
      nomedopai: '',
      periodo: '',
      pkInscricao_na_turma: 0,
      pkPessoa: 0,
      pkTurma: 0,
      resultado: '',
      sexo: '',
      status_2: '',
      telefone: '',
      trasferidoIN: '',
      turma: '',
      unique_field: null
    },
    editedItemPauta: {
      nome: '',
      turma: '',
      anoLectivo: '',
      classe: '',
      disciplina: ''
    },
    itemPauta: null,
    disciplinas: [],
    classes: [
      '10ª Classe',
      '11ª Classe',
      '12ª Classe',
      '13ª Classe'
    ],
    configuracoesReport: []
  }),
  computed: {
    licencaExpirada () {
      return ls.get('licencaExpirada')
    },

    idclasse () {
      return this.$store.state.idclasse
    },
    anolectivo () {
      return ls.get('anolectivo')
    },
    role () {
      return ls.get('role')
    },
    isintegrado () {
      return ls.get('isintegrado')
    },
    isIlha () {
      return (ls.get('i_id') === 24 ? 1 : 0)
    },
    isESCA () {
      return (ls.get('i_id') === 17 ? 1 : 0)
    },
    isNascer () {
      return (ls.get('i_id') === 132 ? 1 : 0)
    },
    instituicaodescricao () {
      return ls.get('instituicaodescricao')
    }
  },

  watch: {

    listaDeClassesPorLancarNotas () {
      this.$store.state.isloading = false
    }
  },
  created () {
    // this.fecharDialog()
    if (ls.get('role') === 'ROLE_COOR') { this.roles = 'coor' }
    this.backTo = ls.get('backTo')
    this.listarEstudantesByTurma()
    this.resetdefaultDocumentos()
    

    //Filtro selected
    this.filtroTurmaSelected = this.filtros[0]
  },

  methods: {

     async filtrarEstudantePorEstado(){

          switch (this.filtroTurmaSelected.id) {
            case 1:
              this.listaAlunosFiltered = this.listEstudantfromPauta // all
            break;
            case 2:
              this.listaAlunosFiltered = this.listEstudantfromPauta.filter( f=>f.estado_estudante === '1' ) // activos
            break;
            case 3:
              this.listaAlunosFiltered = this.listEstudantfromPauta.filter( f=>f.estado_estudante === '0' ) // eliminados
            break;
            case 4:
              this.listaAlunosFiltered = this.listEstudantfromPauta.filter( f=>f.estado_estudante === '2' ) // matrículas tracadas
            break;
          
            default:
              this.listaAlunosFiltered = this.listEstudantfromPauta // all
              break;
          }
           

       },

     

    /** Fecha todos componentes que estiverem abertos */
    resetdefaultDocumentos () {
      this.$store.state.showDialogGuia = { cartao: false,
        carta: false,
        declaracao: false,
        declaracao_nota: false,
        ficha: false,
        guia: false,
        historico: false,
        listaestudante: false,
        estatistica: false,
        planificacaoEstatistica: false,
        boletim: false,
        declaracao_aproveitamento: false,
        mapacontrolavaliacaocontinua: { menu: false, componente: false },
        mapacontroltrimestral: { menu: false, componente: false }
      }
    },
    classe_ (idanoacademico) {
      if (idanoacademico === 1) {
        this.classe = '10ª Classe'
      }
      if (idanoacademico === 2) {
        this.classe = '11ª Classe'
      }
      if (idanoacademico === 3) {
        this.classe = '12ª Classe'
      }
      if (idanoacademico === 4) {
        this.classe = '13ª Classe'
      }

      this.idanoacademico = idanoacademico
    },

    IDano_academico (classe) {
      if (classe === '10ª Classe') {
        return 1
      }
      if (classe === '11ª Classe') {
        return 2
      }
      if (classe === '12ª Classe') {
        return 3
      }
      if (classe === '13ª Classe') {
        return 4
      }
    },

    dialogExcel () {
      if (this.licencaExpirada) {
        Swal.fire('Informação', 'A sua licença de utilização encontra-se expirada! Por favor, entre em contato com o administrador do sistema!', 'info')
      } else {
        this.dialog = true
      }
    },
    loadprogressbar () {
      this.$store.state.isloading = true
    },

    backToTurmas () {
      this.$router.push('painelClassTurma')
    },

    bt_edit (item) {
      this.editedIndex = this.listEstudantfromPauta.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.editedpk = item.pkpauta
      this.editedItem.trimestre = this.$store.state.idperfilpauta
      this.editedItem.pkpauta = item.pkpauta

      setTimeout(() => { }, 1000)
    },
    MostrarDialogo () {
      this.dialog = true
    },

    MostrarDialogoDisabilitar () {
      this.dialogoDisabilita = true
    },

    showAddDisciplina (item) {
      this.itemPauta = item
      this.editedItemPauta = Object.assign(this.editedItemPauta, item)
      this.ObterDisciplinas(item.idCurso, item.idAno_Academico).then((res) => {
        this.disciplinas_ = res
        this.dialogoPauta = true
      })
    },

    async listarEstudantesByTurma () {
      // carrega turma apartir de bauta  Turma
      this.isLoading = true
      try {
        this.listEstudantfromPauta = await axios.get('/ListaEstudantes/' + this.$store.state.objturma.pkTurma).then(res => res.data)
        this.listaAlunosFiltered = this.listEstudantfromPauta
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        Swal.fire({ icon: 'error', title: 'Informação', text: 'Ocorreu um erro ao carregar os estudantes da turma' })
      }
    },

  

    showEliminar (item) {
      this.editedIndex = this.listEstudantfromPauta.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog_delete = true
    },

    async Delete () {
      let params =
      {
        pkInscricaonaTurma: this.editedItem.pkInscricao_na_turma,
        item: this.editedItem,
        autor: ls.get('nomeUsuario')
      }

      try {
        let msg = await axios
          .post('/LixeiraInsertOrUpdate', params)
          .then(res => res.data)
        if (msg.affectedRows >= 1) {
          this.text = 'Estudante eliminado com sucesso'
          Swal.fire({ icon: 'success', title: 'Informação!', text: 'Estudante eliminado(a) com sucesso' })
          this.dialog_delete = false
          this.listEstudantfromPauta.splice(this.editedIndex, 1)
        }
      } catch (error) {
        Swal.fire({ icon: 'error', title: 'Informação!', text: 'Ocorreu um erro ao eliminar o estudante' })
      }
    },

    async ObterDisciplinas (idCurso, idacademico) {
      return await axios
        .post('/disciplina_curso_classe', { idCurso: idCurso, idanoacademico: idacademico, turma: this.itemPauta.pkTurma })
        .then(res => res.data)
    },

    AdicionarDisciplinaPauta () {
      this.disciplinaExistenteNaPauta(this.itemPauta).then((res) => {
        if (res.length) {
          Swal.fire({ icon: 'warning', title: 'Informação!', text: 'Disciplina já existente na Pauta' })
        } else {
          let obj =
          {
            iddisciplina: this.editedItemPauta.disciplina.iddisciplina,
            descricao: this.editedItemPauta.disciplina.disciplina,
            anoacademico: this.itemPauta.idAno_Academico,
            bienal: this.editedItemPauta.disciplina.bienal,
            matricula: this.itemPauta.idMatricula,
            fkInscricao: this.itemPauta.pkInscricao_na_turma,
            pkturma: this.itemPauta.pkTurma,
            bi: this.itemPauta.bi,
            idturma: this.itemPauta.idTurma,
            anolectivo: this.itemPauta.anoLectivo
          }
          this.AddDisciplina(obj).then((res) => {
            if (res.affectedRows >= 1) {
              Swal.fire({ icon: 'success', title: 'Informação', text: 'Disciplina adicionada com sucesso' })
              this.dialogoPauta = false
            } else { Swal.fire({ icon: 'error', title: 'Informação!', text: 'Ocorreu um erro ao tentar adicionar disciplina' }) }
          })
        }
      })
    },

    async disciplinaExistenteNaPauta (item) {
      let obj = { matricula: item.idMatricula, anolectivo: item.anoLectivo, iddisciplina: this.editedItemPauta.disciplina.iddisciplina, pkturma: item.pkTurma, anoacademico: item.idAno_Academico }
      return await axios
        .post('/verificaDisciplinaExistentePauta', obj)
        .then(res => res.data)
    },

    async AddDisciplina (obj) {
      return await axios.post('/add_disciplina_pauta', obj).then(res => res.data)
    },

    async PublicarPauta () {
      const valores =
      {
        turma: this.$store.state.objturma.descricao + '-' + this.$store.state.objturma.pkTurma,
        disciplina: this.$store.state.disciplina,
        bloquear: 1,
        publicar: 1,
        idControlopauta: 0
      }

      // Consumindo a API
      try {
        // eslint-disable-next-line no-unused-vars
        let valor = await axios
          .post('/bloquearPauta', valores)
          .then(res => res.data)
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgSucess', 'timeout': 8000 })
        this.dialog = false

        this.$store.state.bloqueado = []
        // CarregaPauta
        this.verificaPautas()
      } catch (error) {
        Swal.fire({ icon: 'error', title: 'Informação!', text: 'Ocorreu um erro ao bloquear a pauta' })
      }
    },

    async DesbloquearPauta () {
      // Verificando se o Id esta disponivel
      if (this.$store.state.Controlopauta != null) {
        // CONSUMINDO A API ----  Passando a Id
        const valores =
        {
          turma: this.$store.state.objturma.descricao + '-' + this.$store.state.objturma.pkTurma,
          disciplina: this.$store.state.disciplina,
          bloquear: 0,
          publicar: 0,
          idControlopauta: this.$store.state.Controlopauta
        }

        try {
          // eslint-disable-next-line no-unused-vars
          let valor = await axios
            .post('/bloquearPauta', valores)
            .then(res => res.data)
          let text = 'Pauta Bloqueada com sucesso'
          this.$store.dispatch('textMessage', { 'msg': text, 'classMessage': 'msgSucess', 'timeout': 8000 })
          this.dialog = false

          this.$store.state.bloqueado = []
          // CarregaPauta
          this.verificaPautas()

          this.dialogoDisabilita = false
        } catch (error) {
          // this.isLoading = false

          // this.text = error
          this.$store.dispatch('textMessage', {
            msg: error,
            classMessage: 'msgError',
            timeout: 3000
          })
        }
      }
    },

    verificaPautas () {
      this.listaPautasBloquadas = this.$store.state.bloqueado.filter(block => block.turma === this.$store.state.objturma.descricao + '-' + this.$store.state.objturma.pkTurma && block.disciplina === this.$store.state.disciplina && block.publicar === 1 && block.bloquear === 1)
      if (this.listaPautasBloquadas.length) {
        this.$store.state.Controlopauta = this.listaPautasBloquadas[0].idControlopauta
        if (ls.get('role') === 'ROLE_PROF') {
          this.publicar_status = true
          this.btn_activacao = true
          this.btn_description = 'Mini Pauta Bloqueada'
        } else {
          this.publicar_status = true
          this.btn_activacao = false
          this.btn_description = 'Mini Pauta Bloqueada'
        }
      } else {
        this.publicar_status = false
        this.btn_activacao = false
        this.btn_description = 'Publicar'
      }
    },

    editItem (item) {      
      if (this.licencaExpirada) {
        Swal.fire('Informação', 'A sua licença de utilização encontra-se expirada! Por favor, entre em contato com o administrador do sistema!', 'info')
      } else {
        this.tipoDocumento = 'O Boletim'
        this.$store.state.objAluno = item
        if (this.anolectivo >= '2020') { this.$router.push('Novo-Boletim') } else { this.$router.push('Boletim') }
      }
    },

    async findDisciplinaInProfDisc (obj) {
      this.disciplinas = []
      this.$store.state.turma = obj.descricao
      this.$store.state.objturma = obj
      try {
        this.disciplinas = await axios

          .get('/findDisciplinaInProfDisc/' + obj.pkTurma)
          .then(res => res.data)
      } catch (error) {
        Swal.fire({ icon: 'error', title: 'Informação!', text: 'Ocorreu um erro ao tentar encontrar disciplina(s)' })
      }
    },

    async certificadoPago (item) {
      if (this.licencaExpirada) {
        Swal.fire('Informação', 'A sua licença de utilização encontra-se expirada! Por favor, entre em contato com o administrador do sistema!', 'info')
      } else {
        window.open('https://certificado.softlineangola.com/#/login/?q=' + item.idMAtricula + '/' + ls.get('token'), '_blank').focus()
      }
    },

    carregarEstudantesTurmaPDF () {
      this.dialogOpcoes = true
    },

    callGerarLista () {
      try {
        if (this.licencaExpirada) {
          Swal.fire('Informação', 'A sua licença de utilização encontra-se expirada! Por favor, entre em contato com o administrador do sistema!', 'info')
        } else {
          this.titulo = 'A lista de alunos na turma'
          this.$store.state.isloading = false
          this.$store.state.listEstudantfromPauta = this.retornaListaFiltrada(this.listEstudantfromPauta)
          ls.set('modeloimpressao', this.modelo)
          if (!this.$store.state.listEstudantfromPauta.length) {
            Swal.fire('Informação', 'O filtro não encontrou nenhum estudante para exibição.', 'warning')
          } else {
            this.overlay_card = true
            this.$store.state.showDialogGuia.listaestudante = true
          }
        }
      } catch (error) {
        Swal.fire({ icon: 'info', title: '', text: ' não configurada!' })
      } finally {
        this.overlay_card = false
      }
    },

    retornaListaFiltrada (lista) {
      if (this.opcaoImpressao.id === 1) {
        return lista.filter(f => f.resultado === 'Transita' && f.estado_estudante === '1')
      } else if (this.opcaoImpressao.id === 2) {
        return lista.filter(f => f.resultado !== 'Transita' && f.estado_estudante === '1')
      } else { return lista.filter(f => f.estado_estudante === '1') }
    },

    oficioVagas (item) {
      if (this.licencaExpirada) {
        Swal.fire('Informação', 'A sua licença de utilização encontra-se expirada! Por favor, entre em contato com o administrador do sistema!', 'info')
      } else {
        this.titulo = 'O ofício de confirmação de vaga'
        ls.set('relatorio-estudante', { id: 9, descricao: 'Ofício de confirmação de vaga' })
        this.$store.state.objAluno = item
        this.menucomponente = 1
      }
    },
    declaracao_comNotas (item) {
      if (this.licencaExpirada) {
        Swal.fire('Informação', 'A sua licença de utilização encontra-se expirada! Por favor, entre em contato com o administrador do sistema!', 'info')
      } else {
        this.titulo = 'A declaração sem notas'
        ls.set('relatorio-estudante', { id: 8, descricao: 'Declaração sem Notas' })
        this.$store.state.objAluno = item
        this.$store.state.listEstudantfromPauta = this.listEstudantfromPauta
        this.$store.state.showDialogGuia.declaracao_nota = true
      }
    },
    declaracao_aproveitamento (item) {
      if (this.licencaExpirada) {
        Swal.fire('Informação', 'A sua licença de utilização encontra-se expirada! Por favor, entre em contato com o administrador do sistema!', 'info')
      } else {
        this.titulo = 'A declaração de aproveitamento'
        ls.set('relatorio-estudante', { id: 9, descricao: 'Declaração de Aproveitamento' })
        this.$store.state.objAluno = item
        this.$store.state.showDialogGuia.declaracao_aproveitamento = true
      }
    },
    declaracao_semNotas (item) {
      if (this.licencaExpirada) {
        Swal.fire('Informação', 'A sua licença de utilização encontra-se expirada! Por favor, entre em contato com o administrador do sistema!', 'info')
      } else {
        this.titulo = 'A declaração sem notas'
        ls.set('relatorio-estudante', { id: 7, descricao: 'Declaração sem Notas' })
        this.$store.state.objAluno = item
        this.$store.state.listEstudantfromPauta = this.listEstudantfromPauta
        this.$store.state.showDialogGuia.declaracao = true
      }
    },
    async carregarHistoricoAcademico (item) {
      try {
        this.isLoading = true
        let estudantedados = await axios
          .get('/PesquisaGlobal/' + item.idMatricula)
          .then(res => res.data)
        if (estudantedados.length) {
          this.titulo = 'O Histórico Académico'
          ls.set('relatorio-estudante', { id: 1, descricao: 'Histórico Académico' })
          this.$store.state.listEstudantfromPauta = estudantedados
          this.$store.state.objAluno = item
          this.$store.state.showDialogGuia.historico = true
        }
      } catch (error) {
        Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro ao carregar os dados' })
      } finally {
        this.isLoading = false
      }
    },

    async carregarFichaDadosBiograficoAcademico (item) {
      try {
        let estudantedados = await axios
          .get('/PesquisaGlobal/' + item.idMatricula)
          .then(res => res.data)
        if (estudantedados.length) {
          this.titulo = 'A Ficha de Dados Biográfico Académico'
          ls.set('relatorio-estudante', { id: 3, descricao: 'Ficha de Dados Biográfico Académico' })
          this.$store.state.listEstudantfromPauta = estudantedados
          this.$store.state.objAluno = item
          this.$store.state.isloading = true
          this.$store.state.showDialogGuia.ficha = true
        }
      } catch (error) {
        Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro ao carregar os dados' })
      }
    },
    carregarCartaRecomendacao (item) {
      this.titulo = 'A Carta de recomendação'
      ls.set('relatorio-estudante', { id: 4, descricao: 'Carta de recomendação' })
      this.$store.state.objAluno = item
      this.$store.state.isloading = true
      this.$store.state.showDialogGuia.carta = true
    },
    async carregarGuiaTransferencia (item) {
      try {
        let estudantedados = await axios
          .get('/PesquisaGlobal/' + item.idMatricula)
          .then(res => res.data)
        if (estudantedados.length) {
          let i = 0
          estudantedados.forEach(element => {
            if (i < element.idAno_Academico) {
              i = element.idAno_Academico
              this.$store.state.objAluno = element
            }
          })
          this.titulo = 'A Guia de Transferência'
          ls.set('relatorio-estudante', { id: 5, descricao: 'Guia de Transferência' })
          this.$store.state.isloading = true
          this.$store.state.showDialogGuia.guia = true
        }
      } catch (error) {
        Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro ao carregar os dados' })
      }
    },
    carregarcartaoestudante (item) {
      item.anoLectivo = this.$store.state.novadescricaoSelecionado
      this.titulo = 'O Cartão de Estudante'
      ls.set('relatorio-estudante', { id: 6, descricao: 'Cartão de Estudante' })
      this.$store.state.alunoscard = [{
        nome: item.nome.toUpperCase(),
        matricula: item.idMatricula,
        curso: item.curso.toUpperCase(),
        turma: item.turma,
        anolectivo: item.anoLectivo,
        periodo: item.periodo,
        classe: (this.isNascer ? item.classe.replace(new RegExp('Classe', 'g'), '') : item.classe),
        sala: item.sala,
        foto: ls.get('urFoto'),
        codebar: ls.get('urlFoto') + `barCode/` + item.idMatricula
      }]
      this.$store.state.isloading = true
      this.$store.state.showDialogGuia.cartao = true
    },
    getPhoto (item) {
      try {
        return photostudent.getPhotoStudent(item.idMatricula)
      } catch (error) {
        Swal.fire('Informação', 'Ocorreu um erro ao carregar a foto', 'error')
      }
    },
    fecharTelaComponente () {
      this.menucomponente = 0
    }
  }
}
</script>
